module.exports = __webpack_public_path__ + "static/media/contact-section.5b2a7528.png";